export class GenericResponseModel {
    Success: boolean;
    Message: string;
    DecimalValue: number;

    constructor() {
        this.Message = "";
    }
}